export class OtherCost {
    id: number;
    fleet_id: number; 
    driver_id: number;
    provider_id: number;
    user_id: number;
    description: string;
    details: string;
    cost: string;
    date: string;
    date_due: string;
    payment_status_id: number;
    file: string; 

    rego: string;
    driver: string;
    company_name: string;
    status: string;
    user: string; //user display name for logging

}
